import React, { useEffect, useState } from "react";
import {
  Avatar,
  FormLabel,
  ListItem,
  ListItemAvatar,
} from "@mui/material";
import dayjs from "dayjs";
import { TimelineAction, TimelineActionType } from "../../types/Timeline";
import { StartProps } from "../Lessons/Start";
import { NavLink } from "react-router-dom";
import { LoadingButton, Timeline, TimelineConnector, TimelineContent, TimelineItem, TimelineOppositeContent, TimelineSeparator } from "@mui/lab";
import AvatarWrapper from "../Shared/Avatar";
import LessoniceLogo from 'images/logo.png';
import { ItemButtonActions } from "../Solutions/Buttons";
import Api from "../../network/Api";
import wss from "../../channels/consumer";

const TimelineActions = (props: StartProps & ItemButtonActions) => {

  const [history, setHistory] = useState<Array<TimelineAction>>([]);
  const [isLoading, shouldLoad] = useState<boolean>(false);
  const [endReached, setEndReached] = useState<boolean>(false);

  useEffect(() => {
    shouldLoad(true);
    const workspaceSubscription = wss.subscriptions.create("WorkspaceChannel", {
      received(data) {
        switch(data.type) {
          case "timeline_action":
            setHistory(current => [data.timeline_action, ...current] );
            break;
          default: break;
        }
      }
    });
    return () => {
      workspaceSubscription.unsubscribe();
    }
  }, []);

  useEffect(() => {
    if (!isLoading) { return }
    Api.get(`/timeline${history.length > 0 ? `?after=${history[history.length - 1].timestamp}` : ''}`).then(result => {
      shouldLoad(false);
      setHistory(current => {
        let newList = [...current, ...result.items];
        setEndReached(newList.length >= result.total);
        return newList;
      });
    });
  }, [isLoading]);

  const content = (item: TimelineAction) => {
    switch (TimelineActionType[item.action_type]) {
      case TimelineActionType.workspace_created:
        return (
          <small>
            <strong className="text-primary">{item.user.display_name}</strong>
            <br />
            created {props.workspace.name} workspace.
          </small>
        );
      case TimelineActionType.lesson_created:
        return (
          <small>
            <strong className="text-primary">{item.user.display_name}</strong>
            <br />
            added a new lesson learned.
          </small>
        );
      case TimelineActionType.file_imported:
        return (
          <small>
            <strong className="text-primary">{item.user.display_name}</strong>
            <br />
            imported a lessons learned file.
          </small>
        );
      case TimelineActionType.workspace_joined:
        return (
          <small>
            <strong className="text-primary">{item.user.display_name}</strong>
            <br />
            joined {props.workspace.name} workspace.
          </small>
        );
      case TimelineActionType.solution_approved:
        return (
          <small>
            <strong className="text-primary">{item.user.display_name}</strong><br />approved a <NavLink to={`/lessons/${item?.lesson?.id}`}>solution</NavLink>.
          </small>
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      {history.length > 0 && (
      <Timeline sx={{p: 0, mb: 0}}>
        {history.map(item => {
        return <>
          <TimelineItem>
            <TimelineOppositeContent sx={{px: 0, textAlign: "center", lineHeight: 1.2}}>
              <FormLabel sx={{fontSize: "0.7rem !important"}}>
                {dayjs.unix(item.timestamp).format("ll")}
              </FormLabel>
            </TimelineOppositeContent>
            <TimelineSeparator sx={{flexGrow: 1}}>
              <TimelineConnector />
              <ListItemAvatar sx={{my: "0.5rem !important", minWidth: 0}}>
                { item.user ? 
                  <AvatarWrapper size={32} user={item.user} color={item.user.id === props.user.id ? "primary" : "secondary"} />
                  : <Avatar sx={{width: 32, height: 32, backgroundColor: 'var(--background-secondary) !important'}}><img src={LessoniceLogo} width="75%" height="75%" /></Avatar> }
              </ListItemAvatar>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{px: 0, flexGrow: 2, lineHeight: 1.2}}>{content(item)}</TimelineContent>
          </TimelineItem>
        </>})}

        { !endReached && <ListItem sx={{justifyContent: "center"}} disablePadding>
        <LoadingButton variant="text" 
                        size="small" 
                        loading={isLoading}
                        onClick={() => shouldLoad(true)}>Load more</LoadingButton>
      </ListItem> }
      
      </Timeline>
    )}
  </>
  );
};

export default TimelineActions;
